import type { SxProps, Theme } from '@mui/material/styles';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation.ts';

export const accordionStyles: SxProps = {
  mb: 2.5,

  '&.MuiAccordion-root': {
    border: 1,
    borderColor: 'divider',
    borderRadius: 1,
    boxShadow: ELEVATION.elevation0,
    backgroundColor: 'background.paper',

    '&:before': {
      display: 'none',
    },
  },

  '&.Mui-disabled': {
    backgroundColor: 'transparent',
  },

  '&.Mui-expanded': {
    marginBottom: 2.5,
  },

  '.criteria-error &.MuiAccordion-root': {
    borderColor: 'error.main',
    borderRadius: 0,
  },
};

export const getAccordionSummaryStyles = (expandable: boolean, theme: Theme): SxProps<Theme> => ({
  backgroundColor: 'background.paper',
  cursor: expandable ? 'pointer' : 'default !important',
  padding: theme.spacing(2, 3),

  '& .MuiAccordionSummary-content': {
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    display: expandable ? 'flex' : 'none',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: expandable ? theme.spacing(3) : 0,
    height: 3,
    transition: expandable ? 'transform 0.2s' : 'none',
    transform: !expandable ? 'none !important' : undefined,
  },
});
